import type { Image } from '../types/Image';
import { TYPES } from '../utils/constants/ImageType';

const validImageTypes = TYPES;

export function $getValidImageTypes() {
  return validImageTypes;
}

export function $getAvatar(image: string | Image, thumbnail?: boolean) {
  if (typeof image === 'string' || image instanceof String) {
    return image;
  }

  return typeof image === 'object' ? (thumbnail ? image.thumb_url || image.url : image.url || image.thumb_url) : false;
}

export function $toMb(size: number) {
  return size ? size / 1024 / 1024 : 0;
}

export function $isHeicFile(file: File) {
  return ['heic', 'heif', 'heif-sequence', 'heic-sequence'].includes($getImageFileType(file)[1] as string);
}

export function $isImageFile(file: File) {
  const type = $getImageFileType(file)[0];
  return type === 'image';
}

export function $isImageValidType(file: File) {
  const type = $getImageFileType(file)[1] as string;
  return validImageTypes.includes(type);
}

export function $getImageFileType(file: File) {
  return file.type.split('/');
}

export function $parseImage(file: File): Promise<string | ArrayBuffer | null | undefined> {
  return new Promise(function (resolve) {
    if (file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        resolve(e.target?.result);
      };
      reader.readAsDataURL(file);
    }
  });
}
